
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'locationText': {'fontFamily': `'Lato-Regular-Regular', sans-serif`,'marginBottom': `16px`,'color': `#000000`,},'hours': {'marginBottom': `16px`,},'locationHoursHeading': {'fontFamily': `'Lato-Regular-Bold', sans-serif`,'fontSize': `small`,'fontWeight': `bold`,'marginBottom': `8px`,'color': `#000000`,'paddingLeft': `6px`,},'businessHours': {'marginBottom': `8px`,'color': `#000000`,'paddingLeft': `6px`,},'regularHours': {'marginBottom': `8px`,'color': `#000000`,'paddingLeft': `6px`,},'holidayHours': {'fontFamily': `'Lato-Regular-Regular'`,'fontStyle': `italic`,'marginBottom': `8px`,'color': `#9d2a21`,'paddingLeft': `6px`,},
        
      };
    };
  